<template>
  <div :class="[companyClass, canScroll]" v-show="userPermissionsFilter.addexchangerates">
    <div class="page-exchangerates flex column mb-20">
      <div class="page-header">
        <h1 class="pageTitle">Upload Exchange Rate</h1>
        <h4>new exchange rate</h4>
        <div id="plug">
          <div v-if="showTimer" class="v" style="color:red">We are moving this module to <a :href=newbackofficeurl
              target="_blank">New
              Backoffice</a>. This module will be permanently disabled in {{ timerOutput }}</div>
          <div v-else class="v"></div>
        </div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
          <el-breadcrumb-item>settings</el-breadcrumb-item>
          <el-breadcrumb-item>exchange rates</el-breadcrumb-item>
          <el-breadcrumb-item>add ex-rates</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="mt-0 w-100">
        <div style="float: right">
          <el-button v-show="userPermissionsFilter.uploadexchangerates" type="primary" icon="el-icon-plus"
            @click="handleNew"></el-button>

          <el-button v-show="userPermissionsFilter.viewexchangerates" type="warning" icon="el-icon-tickets"
            @click="handleExit"></el-button>

          <el-button type="primary" @click="validateAndSave" v-show="canSaveChanges" :disabled="saveChanges">
            <i class="mdi mdi-content-save"></i></el-button>
        </div>
      </div>

      <div class="mt-10">
        <div>
          <el-radio-group v-model="exType" size="small">
            <el-radio-button label="Customer Ex-Rate"></el-radio-button>
            <el-radio-button label="Partner/GL Ex-Rate"></el-radio-button>
          </el-radio-group>
        </div>
        <el-row :gutter="20">
          <el-col :span="6">
            <span>From Date</span><span :class="required"> *</span>
            <el-date-picker v-model="exchangeRate.fromDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"
              placeholder="Start Date" name="fromdate" :picker-options="{ disabledDate: disableAllDatesBeforeToday }"
              v-validate="'required'" @blur="propertyChanged" v-on:change="fromDateChanged" data-vv-as="start date"
              :disabled="readOnlyMode">
            </el-date-picker>
            <transition name="fade">
              <span class="danger-text">{{ errors.first("fromdate") }}</span>
            </transition>
          </el-col>
          <el-col :span="6">
            <span>To date</span><span :class="required"> *</span>
            <el-date-picker v-model="exchangeRate.toDate" style="width: 100%" type="date" value-format="yyyy-MM-dd"
              placeholder="End Date" name="todate" :picker-options="{ disabledDate: disableAllDatesBeforeToday }"
              v-validate="'required'" @blur="propertyChanged" data-vv-as="end date" :disabled="readOnlyMode">
            </el-date-picker>
            <transition name="fade">
              <span class="danger-text">{{ errors.first("todate") }}</span>
            </transition>
          </el-col>
          <el-col :span="6">
            <span>From Time</span><span :class="required"> *</span>
            <el-time-picker v-model="exchangeRate.fromTime" placeholder="Start time" name="fromtime" style="width: 100%"
              value-format="HH:mm:ss" v-validate="'required'" @blur="propertyChanged" @change="fromTimeChanged"
              data-vv-as="start time" :disabled="readOnlyMode">
            </el-time-picker>
            <transition name="fade">
              <span class="danger-text">{{ errors.first("fromtime") }}</span>
            </transition>
          </el-col>
          <el-col :span="6">
            <span>To Time</span><span :class="required"> *</span>
            <el-time-picker v-model="exchangeRate.toTime" placeholder="End time" name="endtime" style="width: 100%"
              value-format="HH:mm:ss" v-validate="'required'" @blur="propertyChanged" data-vv-as="end time"
              :disabled="readOnlyMode">
            </el-time-picker>
            <transition name="fade">
              <span class="danger-text">{{ errors.first("endtime") }}</span>
            </transition>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-10">
          <el-col :span="6" v-show="exType === 'Partner/GL Ex-Rate'">
            <span>Partner</span>
            <el-select v-model="exchangeRate.partnerID" filterable clearable placeholder="Partner" class="mb-10"
              style="width: 100%" :disabled="readOnlyMode" @change="propertyChanged">
              <el-option v-for="company in companyNames" :key="company.id" :label="company.name" :value="company.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <!-- <span>Exchange Rate File</span><span :class="required"> *</span> -->
            <el-button @click="onPickFile">
              Upload Exchange Rate Files
            </el-button>
            <input type="file" style="display: none" @change="onFilePicked" ref="fileInput" />
            <transition name="fade">
              <span class="danger-text">{{ errors.first("rate") }}</span>
            </transition>
          </el-col>
        </el-row>
        <div class="mt-10">
          <el-button type="primary" v-show="!readOnlyMode" @click="validateAndSave"><i></i> Upload
            ExchangeRates</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PermissionsMixins from "@/mixins/PermissionsMixins";
import router from "@/router/";

export default {
  name: "UploadExchangeRate",
  data() {
    return {
      activateNotification: false,
      timespan: "",
      timepspantype: "",
      exType: "Customer Ex-Rate",
      exchangeRate: {
        fromCurrencyID: "",
        toCurrencyID: "",
        countryID: "",
        partnerID: "",
        rate: "",
        runningFrom: "",
        runningTo: "",
        fromTime: "",
        toTime: "",
        notificationActive: false,
        timespan: 0,
        timeSpanType: "",
        notificationPhoneNumbers: "",
        notificationEmails: "",
        file: null,
      },
      newbackofficeurl: "",
      countDownToTime: new Date('Oct 15, 2024 00:00:00').getTime(),
      timerOutput: '',
      showTimer: true
    };
  },
  computed: {
    canSaveChanges() {
      return this.saveChanges && !this.readOnlyMode;
    },
    readOnlyMode() {
      return !(
        this.userPermissionsFilter.uploadexchangerates ||
        this.userPermissionsFilter.editexchangerates
      );
    },
  },
  methods: {
    fromDateChanged(e) {
      if (!this.exchangeRate.toDate) this.exchangeRate.toDate = e;
    },
    fromTimeChanged(e) {
      var newTime =
        parseInt(e.split(":")[0]) +
        1 +
        ":" +
        e.split(":")[1] +
        ":" +
        e.split(":")[2];
      if (!this.exchangeRate.toTime) this.exchangeRate.toTime = newTime;
    },
    onPickFile() {
      var elem = this.$refs.fileInput;

      elem.click();
    },
    onFilePicked(event) {
      const files = event.target.files;

      this.exchangeRate.file = files[0];

      console.log(this.exchangeRate);
    },
    createNew() {
      router.push("/uploadexchangerate");
      this.clearState();
    },
    viewRates() {
      router.push("/exchangerates");
    },
    clearState() {
      this.exchangeRate = {
        fromCurrencyID: "",
        toCurrencyID: "",
        countryID: "",
        partnerID: "",
        rate: "",
        runningFrom: "",
        runningTo: "",
        fromDate: "",
        toDate: "",
        fromTime: "",
        toTime: "",
        notificationActive: false,
        timespan: 0,
        timeSpanType: "",
        notificationPhoneNumbers: "",
        notificationEmails: "",
      };

      this.$validator.reset();
    },
    submitExchangeRate() {

      var formData = new FormData();

      formData.append("file", this.exchangeRate.file);

      formData.append("status", 0);

      formData.append("fromTime", this.exchangeRate.fromTime);

      formData.append("toTime", this.exchangeRate.toTime);

      formData.append("toDate", this.exchangeRate.toDate);

      formData.append("fromDate", this.exchangeRate.fromDate);

      this.uploadExchangeRate(formData).then((result) => {
        if (result.item1 && result.item1 == true) {
          this.successMessage("Exchange rate was uploaded successfully.");
          this.clearState();
          this.entitySaved();
          router.push("/exchangeratesfileuploadlist");
        } else {
          this.errorMessage(
            "Failed to upload exchange rate, makes sure there are no other rates uploaded on the specified dates."
          );
        }
      });
    },
    validateAndSave() {
      let self = this;
      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            this.submitExchangeRate();
          }
        })
        .catch((err) => console.log(err));
    },
    setCurrent() {
      var id = router.currentRoute.params.id;

      this.pageTitle = "Add Exchange Rate";
      this.pageSubtitle = "create exchange rate";

      if (id) {
        this.canDelete = true;
        this.pageTitle = "exchange rate info";
        this.findExchangeRateById(id).then((result) => {
          if (result) {
            console.log(result);
            this.exchangeRate = result;
            this.pageSubtitle = "view exchange rate info";
            this.exchangeRate.fromDate = result.runningFrom;
            this.exchangeRate.toDate = result.runningTo;

            var fromDatetime = new Date(result.runningFrom);
            var toDatetime = new Date(result.runningFrom);
            this.exchangeRate.fromTime = fromDatetime;
            this.exchangeRate.toTime = toDatetime;
          }
        });
      }
    },
  },
  created() {
   
    this.startTimer();
    let self = this;
    this.newbackofficeurl = self.$newbackofficeurl;
  
    this.newEvent = "createNew";
    this.saveEvent = "validateAndSave";
    this.exitEvent = "viewRates";
    this.$on(this.saveEvent, this.validateAndSave);
    this.$on(this.newEvent, this.createNew);
    this.$on(this.exitEvent, this.viewRates);

    this.getCountries();
    this.getCompanyNames();
    this.getCurrencies();
    this.setCurrent();
  },
  mixins: [PermissionsMixins],
};
</script>


<style lang="scss" scoped>
@import "../../assets/scss/_variables";
</style>